var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0742 26.7812C21.7313 26.7812 27.1279 21.3846 27.1279 14.7275C27.1279 8.07045 21.7313 2.67383 15.0742 2.67383C8.41713 2.67383 3.02051 8.07045 3.02051 14.7275C3.02051 21.3846 8.41713 26.7812 15.0742 26.7812Z",
    fill: "#50B651"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.663,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0919 14.695C27.0919 21.373 21.6784 26.7865 15.0019 26.7865C8.3254 26.7865 2.9104 21.373 2.9104 14.695C2.9104 11.7409 2.9932 11.3017 4.156 9.61989C4.156 9.61989 4.096 11.5195 5.4889 12.6499C6.355 13.3522 7.2589 12.8452 8.9134 12.0832C10.7032 11.2582 12.1582 10.726 13.2934 10.8664C15.0034 11.0782 20.2741 14.2435 23.0248 13.6132C25.2223 13.1107 24.9904 7.92969 24.9904 7.92969C27.3904 10.2733 27.0919 11.8573 27.0919 14.695Z",
    fill: "url(#paint0_linear_755_77842)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.586,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1904 23.5752C24.5634 19.4618 25.2903 14.7494 22.3711 9.43796C22.3859 9.44876 22.5665 8.82556 22.9129 7.56836C24.4665 9.44976 25.2926 11.772 25.3912 14.535C25.3904 18.1138 23.6568 21.1272 20.1904 23.5752Z",
    fill: "url(#paint1_linear_755_77842)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.744,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1162 7.59315C16.0054 6.42495 13.5838 4.07505 13.9057 3.58155C14.2276 3.08805 18.4057 3.17295 20.5168 4.34115C22.6279 5.50935 24.4246 9.01365 24.103 9.50715C23.7814 10.0007 20.227 8.76135 18.1162 7.59315Z",
    fill: "url(#paint2_radial_755_77842)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9544 17.6975C18.2033 17.6975 16.7837 16.2374 16.7837 14.4365C16.7837 12.6356 18.2033 11.1758 19.9544 11.1758C21.7055 11.1758 23.1254 12.6356 23.1254 14.4365C23.1254 16.2374 21.7058 17.6975 19.9544 17.6975ZM19.9769 16.6631C21.0698 16.6631 21.9569 15.6662 21.9569 14.4365C21.9569 13.2068 21.0698 12.2108 19.9769 12.2108C18.884 12.2108 17.9969 13.2077 17.9969 14.4371C17.9969 15.6665 18.884 16.6631 19.9769 16.6631Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4119 8.54883H15.6967V17.6598H14.4424V9.54813H13.4119V8.54883Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7094 11.2681H12.8953V18.8767C12.8953 19.57 12.166 20.2921 11.4553 20.6029C11.1193 20.7497 10.4993 20.8369 9.59531 20.8645V20.1076C10.4795 20.009 11.0763 19.8123 11.3857 19.5175C11.5643 19.2694 11.6758 18.9795 11.7097 18.6757V16.4404C11.3927 17.113 10.9935 17.5589 10.5121 17.7781C10.0117 18.0481 8.99321 18.0037 8.57741 17.7781C8.16161 17.5525 7.55171 16.9585 7.27211 16.0738C7.19471 15.8296 7.00211 15.1651 7.02221 14.461C7.04021 13.7905 7.26221 13.081 7.44671 12.7894C7.76351 12.2914 8.26301 11.6677 9.01961 11.407C9.38921 11.2796 10.0742 11.2338 11.0746 11.2696V12.0223C10.3312 11.9721 9.86741 11.9972 9.68321 12.0976C9.40691 12.2476 8.78321 12.4327 8.57741 13.792C8.37161 15.1513 8.58341 16.2637 9.23591 16.612C9.45941 16.732 9.85481 16.8739 10.2202 16.7488C10.9222 16.5088 11.5828 15.6529 11.6332 15.073C11.684 14.4846 11.7094 13.2163 11.7094 11.2681Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7128 17.1152C25.5929 22.5077 20.8145 26.5595 15.0902 26.5595C8.53428 26.5595 3.21948 21.2447 3.21948 14.6888C3.21948 10.616 5.27058 7.02227 8.39598 4.88477C5.85648 6.99077 4.23948 10.1723 4.23948 13.73C4.23948 20.0759 9.38388 25.22 15.7295 25.22C20.8973 25.22 25.2677 21.8087 26.7128 17.1152Z",
    fill: "url(#paint3_radial_755_77842)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0898 0.630859C7.32579 0.630859 1.03149 6.92486 1.03149 14.6889C1.03149 22.4529 7.32579 28.7472 15.0898 28.7472C22.8538 28.7472 29.1481 22.4529 29.1481 14.6889C29.1481 6.92486 22.8538 0.630859 15.0898 0.630859ZM15.0898 26.5599C8.53389 26.5599 3.21909 21.2451 3.21909 14.6892C3.21909 10.6164 5.27019 7.02266 8.39559 4.88516C10.3667 3.53518 12.7007 2.81448 15.0898 2.81816C21.6457 2.81816 26.9605 8.13266 26.9605 14.6889C26.9609 15.504 26.8778 16.3171 26.7124 17.1153C25.5925 22.5078 20.8141 26.5596 15.0898 26.5596V26.5599Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_755_77842",
    x1: 14.5348,
    y1: 9.58089,
    x2: 16.0846,
    y2: 23.5768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#123214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3E7C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5FBB46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_755_77842",
    x1: 23.4882,
    y1: 8.66975,
    x2: 23.4882,
    y2: 19.9874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "white",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_755_77842",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.2612 6.62364) rotate(26.7606) scale(5.95629 2.48069)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_755_77842",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.1257 11.9537) rotate(39.84) scale(13.3479 14.5492)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlo);
export default __webpack_public_path__ + "static/media/glo.759054824a20b695ee61ac2cae46b850.svg";
export { ForwardRef as ReactComponent };